<ng-container *ngIf="jobOrders.length">
  <div class="job-orders">
    <table
      matSort
      mat-table
      [dataSource]="jobOrders"
      (matSortChange)="sortData($event)"
    >
      <ng-container matColumnDef="jobName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head">Job name</span>
        </th>
        <td mat-cell (click)="onDetailClick(job.id)" *matCellDef="let job">
          <span class="fc-cell-text fc-cell-name">{{ job.code }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="finalCustomer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head">Final customer</span>
        </th>
        <td mat-cell (click)="onDetailClick(job.id)" *matCellDef="let job">
          <span class="fc-cell-text">{{ job.finalCustomer }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="deliveryDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head">Delivery date</span>
        </th>
        <td mat-cell (click)="onDetailClick(job.id)" *matCellDef="let job">
          <span class="fc-cell-text fc-mono">{{ job.deliveryDate | date:'shortDate' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head">Start date</span>
        </th>
        <td mat-cell (click)="onDetailClick(job.id)" *matCellDef="let job">
          <span class="fc-cell-text fc-mono">{{ job.startDate | date:'shortDate' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head">End date</span>
        </th>
        <td mat-cell (click)="onDetailClick(job.id)" *matCellDef="let job">
          <span class="fc-cell-text fc-mono">{{ job.endDate | date:'shortDate' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="ops">
        <th mat-header-cell *matHeaderCellDef>
          <span class="item-head">Actions</span>
        </th>
        <td mat-cell *matCellDef="let job">
          <button (click)="onUpdateClick(job.id)" mat-icon-button>
            <mat-icon aria-label="Update">create</mat-icon>
          </button>
          <button (click)="onDeleteClick(job.id)" mat-icon-button>
            <mat-icon aria-label="Delete">delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
    </table>
  </div>
</ng-container>
